import { render, staticRenderFns } from "./institutions-select.vue?vue&type=template&id=02f70451&"
import script from "./institutions-select.vue?vue&type=script&lang=js&"
export * from "./institutions-select.vue?vue&type=script&lang=js&"
import style0 from "./institutions-select.vue?vue&type=style&index=0&id=02f70451&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports